// Reorderable items of the main navigation. Logout stays at the end.
export const NAVIGATION_ITEMS = ["compose", "home", "notifications", "explore", "public", "direct", "bookmarks", "drafts", "scheduled_statuses", "favourites", "lists", "account_settings", "app_settings"];

// These items can be moved but not hidden.
export const NAVIGATION_FIXED_ITEMS = ["compose", "account_settings", "app_settings"];

// The order is stored as a comma separated string in the local setting
// `navigation_order`. Unknown ids are dropped, missing ids are appended in the default order.
export const parseNavigationOrder = (value) => {
  const saved = typeof value === "string" ? value.split(",") : [];
  const ordered = [];

  saved.forEach(id => {
    if (NAVIGATION_ITEMS.includes(id) && !ordered.includes(id)) {
      ordered.push(id);
    }
  });

  NAVIGATION_ITEMS.forEach(id => {
    if (!ordered.includes(id)) {
      // Items added later: the compose button leads the menu, everything else is appended.
      if (id === "compose") {
        ordered.unshift(id);
      } else {
        ordered.push(id);
      }
    }
  });

  return ordered;
};

export const serializeNavigationOrder = (ids) => ids.join(",");

// Ausgeblendete Eintraege: ebenfalls kommagetrennt in `navigation_hidden`.
export const parseNavigationHidden = (value) => {
  const saved = typeof value === "string" ? value.split(",") : [];
  return NAVIGATION_ITEMS.filter(id => saved.includes(id) && !NAVIGATION_FIXED_ITEMS.includes(id));
};
